module.exports = __webpack_public_path__ + "static/card-recreate-do-d826023a99a1b6d387bbbd9cf4899d6a.png";